export default [{
  path: 'ruleAdd',
  name: 'ruleAdd',
  component: function component() {
    return import('@/views/systemManage/add');
  }
}, {
  //公司
  path: 'ruleCompany',
  name: 'ruleCompany',
  component: function component() {
    return import('@/views/systemManage/companyList');
  }
}, {
  //股份
  path: 'ruleShare',
  name: 'ruleShare',
  component: function component() {
    return import('@/views/systemManage/shareList');
  }
}, {
  //分局
  path: 'ruleBranch',
  name: 'ruleBranch',
  component: function component() {
    return import('@/views/systemManage/branchList');
  }
}];